<template>
  <div class="childPannel">
    <!-- <el-input
      v-model="filterValue"
      style="width: 100%; margin-bottom: 12px"
      placeholder="通过编号、简称、站点名称进行搜索"
      :prefix-icon="Search"
    /> -->
    <div v-if="list.length" class="childPannel-box">
      <div v-for="m in list" :key="m.id" @click="handleClickItem(m)" class="childPannel-box-item">
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">编号：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.id }}</span>
          </div>
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">位置：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.name }}</span>
          </div>
        </div>
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label"></span>
            <span class="childPannel-box-item-block-info-value">{{ m.description }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-empty v-if="!list.length" :image-size="100" description="当前内容为空" />
    <el-pagination
      class="childPannel-pagination"
      v-else
      size="small"
      v-model:current-page="params.pageNum"
      :page-size="params.pageSize"
      background
      :pager-count="5"
      @change="getList"
      layout="prev, pager, next"
      :total="total"
    />
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref, watch } from 'vue'
import { toCameraPosition } from './utils'
import { LayerPopupCtrl } from '@/components/LayerPopupCtrl'
import { CesiumObj } from '@/components/GIS/CesiumObj'
import { Cartographic, Math } from 'cesium'
import type { ICameraData } from '@/apiFzn/types'
import { getCameraDataInfo } from '@/apiFzn'
import CameraPopup from '../../Popup/CameraPopup.vue'

const popupCtrl = LayerPopupCtrl.getInstance();
let cesiumobj: CesiumObj | null = null

const handleClickItem = async (m: ICameraData) => {
  if (!cesiumobj) cesiumobj = await CesiumObj.getInstance()

  popupCtrl.popupMap.forEach((val) => {
    val.destroy()
  })

  toCameraPosition({
    lng: m.longitude,
    lat: m.latitude,
  })
  const cartographic = Cartographic.fromDegrees(m.longitude, m.latitude, 0)
  popupCtrl.popup({
    viewer: cesiumobj.viewer,
    id: m.id,
    lnglat: [cartographic.longitude, cartographic.latitude].map(Math.toDegrees) as [number, number],
    Com: CameraPopup,
    properties: m,
  })
}

// const filterValue = ref('')
const props = defineProps({
  showPannelKey: {
    type: String,
    default: '',
  },
  searchValue: {
    type: String,
    default: '', // 提供默认值
  },
})

const params = reactive({
  name: '',
  pageNum: 1,
  pageSize: 8,
})

const list = ref<ICameraData[]>([])
const total = ref(0)

const getList = () => {
  getCameraDataInfo(params).then((res) => {
    list.value = res.rows
    total.value = res.total
  })
}

defineExpose({
  getList,
})

watch(
  () => props.searchValue,
  (newVal) => {
    params.name = newVal
    params.pageNum = 1
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
@import url('./childPannel.scss');
</style>
